import { AuthRepository } from "../../../../data/repository/auth/AuthRepository";
import { TruckRepository } from "../../../../data/repository/truck/TruckRepository";
import { AccessToken, Auth } from "../../../model/Auth";
import { ResponseState, State } from "../../../model/ResponseState";
import { FilterTrucksByModel, Truck } from "../../../model/Truck";

export interface GetAllTrucksUseCase {
  invoke: (
    skip?: number,
    limit?: number,
    filterTrucksByModel?: FilterTrucksByModel
  ) => Promise<ResponseState<Array<Truck>>>;
}

export class GetAllTrucksUseCaseImpl implements GetAllTrucksUseCase {
  private repo: TruckRepository;

  constructor(repo: TruckRepository) {
    this.repo = repo;
  }

  async invoke(
    skip?: number,
    limit?: number,
    filterTrucksByModel?: FilterTrucksByModel
  ): Promise<ResponseState<Array<Truck>>> {
    try {
      let response = await this.repo.getAll(skip, limit, filterTrucksByModel);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
